import React, { Component } from 'react'
// import { Tabs } from 'antd';
import img1 from '../../../static/images/agricultural-banner.jpg'
import product3 from '../../../static/images/product-3.png'

import integration from '../../../static/images/yitihuan.png'
import supermarket2 from '../../../static/images/icon-select.png'
import supermarket3 from '../../../static/images/sulution-agrutucal.png'

import superIcon1 from '../../../static/images/supuer-icon-1.png'

import advantage1 from '../../../static/images/chain-icon-1.png'
import advantage2 from '../../../static/images/super-img-2.png'

import sceen from '../../../static/images/agrtucal-sceen.png'
import speacial from '../../../static/images/agrtucal-speacial.png'
import plan from '../../../static/images/agrtucal-excample.png'





import './index.less';
class SupermarketRetail extends Component {
    state = {
        customerList: [
            { img: superIcon1, title: '促销特价/折扣' },
            { img: superIcon1, title: '单品打折' },
            { img: superIcon1, title: '类别打折' },
            { img: superIcon1, title: '全场打折' },
            { img: superIcon1, title: '供应商打折' },
            { img: superIcon1, title: '组合特价' },
            { img: superIcon1, title: '组合打折' },
            { img: superIcon1, title: '赠品促销' },
            { img: superIcon1, title: '采购促销特价' },
            { img: superIcon1, title: '超量特价' },
            { img: superIcon1, title: '超量折扣' },
            { img: superIcon1, title: '超额折扣' },
            { img: superIcon1, title: '满减' },
            { img: superIcon1, title: '满赠' },
            { img: superIcon1, title: '买M赠N' },
            { img: superIcon1, title: '更多' },
        ],
        partnerList: [
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
            { img: product3 },
        ],
    }
    onEvents() { }
    render() {
        const { customerList } = this.state
        return (
            <div className="product_container unattended-container supermarket-container pos-container agricultural-container">
                <div className="top-home-carousel">
                    <div className="banner-bg"><img className="banner-img" src={img1} alt="" /></div>
                    <div className="mode-mark"></div>
                    <div className="mask-top-content">
                        <div className="content-pos">
                            <div className="content-left-text">
                                <div className="banner-top-title">悦喵AI-农贸市场解决方案</div>
                                <div className="banner-top-tips">以技术为核心，数智化运营赋能农贸市场，完善食安追溯体系，实现全流程数字化管理，打通线上线下，提高供应链效率，帮助市场转型升级，降本增效。</div>
                
                            </div>
                            
                        </div>
                        
                    </div>
                </div>


                <div className="common-block-home product-page">
                    <div className="common-block-home-title">传统农贸市场现状</div>
                    <div className="common-block-home-tips">传统农贸市场问题频出</div>
                    <div className="common-block-product">
                        <div className="product-detail product-detail-page unattended-first-page">
                            <div className="index-title">
                                <div className="index-num">01</div>
                                <div className="product-detail-title-1">不能满足人民群众对美好生活的向往</div>
                            </div>
                            <div className="product-detail-tips">硬件环境差、服务质量差、商品品质没有保障</div>
                        </div>
                        <div className="product-detail product-detail-page unattended-first-page">
                           
                            <div className="index-title">
                                <div className="index-num index-num-2">02</div>
                                <div className="product-detail-title-1">经营方式落后</div>
                            </div>
                            <div className="product-detail-tips">以个体经营为主，随意性大，经营管理水平受个体能力制约，缺乏建设具有现代经营管理理念的运作机制和手段</div>
                        </div>
                        <div className="product-detail product-detail-page unattended-first-page">
                            
                            <div className="index-title">
                                <div className="index-num index-num-3">03</div>
                                <div className="product-detail-title-1">不利于国家对于食品安全的有效监管</div>
                            </div>
                            <div className="product-detail-tips">渠道分散、管理分散、信息分散，无法为市场监管提供及时、准确、可靠的科学依据</div>
                        </div>
                        <div className="product-detail product-detail-page unattended-first-page">
                            
                            <div className="index-title">
                                <div className="index-num index-num-4">04</div>
                                <div className="product-detail-title-1">无法有效对接各类社会资源</div>
                            </div>
                            <div className="product-detail-tips">个体经营力量弱、风险高，银行、物流、大型供应链核心企业、电商企业等各类社会资源对其望而却步</div>
                        </div>
                        
                    </div>

                </div>

                <div className="common-block-home">
                    <div className="common-block-home-title">农贸市场经营五大思考</div>
                    <div className="ponder-over">
                        <div className="ponder-over-detail">
                            <img className="ponder-over-img-style" src={supermarket2} alt="" />
                            <div className="ponder-over-title">消费客流增长</div>
                        </div>
                        <div className="ponder-over-detail">
                            <img className="ponder-over-img-style" src={supermarket2} alt="" />
                            <div className="ponder-over-title">消费客流增长</div>
                        </div>
                        <div className="ponder-over-detail">
                            <img className="ponder-over-img-style" src={supermarket2} alt="" />
                            <div className="ponder-over-title">消费客流增长</div>
                        </div>
                        <div className="ponder-over-detail">
                            <img className="ponder-over-img-style" src={supermarket2} alt="" />
                            <div className="ponder-over-title">消费客流增长</div>
                        </div>
                        <div className="ponder-over-detail">
                            <img className="ponder-over-img-style" src={supermarket2} alt="" />
                            <div className="ponder-over-title">消费客流增长</div>
                        </div>
                    </div>
                    
                </div>

                <div className="common-block-home">
                    <div className="common-block-home-title" style={{ marginBottom: 0, }}>一站式解决方案</div>
                    <div className="common-block-home-tips" style={{ marginTop: '30px', lineHeight: '26px',padding: '0 80px' }}>以数字化平台为抓手，聚合软硬件前后端新技术、新产品等，为政府、市场管理方、商户、消费者，提供食品安全监督、精细化管理、线上线下精准运营、数据分析等一站式数智化服务。</div>
                    <div className="member-detail-service member-detail-service-1">
                        <img className="member-img-style" src={supermarket3} alt="" />
                    </div>
                </div>

               

                <div className="common-block-home product-page">
                    <div className="common-block-home-title">创新经营模式</div>
                    <div className="common-block-home-tips">智慧农贸下的创新经营模式</div>
                    <div className="content-detail-create">农贸市场不断发展变革，客户购买环境不断优化升级，在新农贸的大背景下，市场经营策略不断革新，除传统物业管理模式外，有了更多选择。一方面，通过系统智能管理，降低市场经营成本，提高效率；另一方面，加强对市场经营的参与，统一管理收银，把握市场经营关键数据。</div>
                    <div className="content-bottom-style">
                        <div className="content-bottom-style-left">
                            <div className="left-detail-flex">
                                <img className="member-img-style" src={supermarket2} alt="" />
                                <div className="left-detail-flex-title">费用收入</div>
                            </div>
                            <div className="left-detail-flex">
                                <img className="member-img-style" src={supermarket2} alt="" />
                                <div className="left-detail-flex-title">收银提点</div>
                            </div>
                            <div className="left-detail-flex">
                                <img className="member-img-style" src={supermarket2} alt="" />
                                <div className="left-detail-flex-title">聚合支付</div>
                            </div>
                        </div>
                        <div className="content-bottom-style-center">
                            <div className="center-detail-block">
                                <div className="block-line-title">传统物业管理模式，基本营收来源；</div>
                                <div className="block-line-title">不同商户设置不同费用</div>
                            </div>
                            <div className="center-detail-block">
                                <div className="block-line-title">掌握商户销售情况，分段提点；</div>
                                <div className="block-line-title">降低商户入驻门槛，提升商户质量</div>
                            </div>
                            <div className="center-detail-block">
                                <div className="block-line-title">接入统一的聚合支付平台；</div>
                                <div className="block-line-title">增加市场方服务价值，增强用户粘性</div>
                            </div>
                        </div>
                        <div className="content-bottom-style-right">创新营收点</div>
                    </div>
                </div>

                <div className="common-block-home">
                    <div className="common-block-home-title" style={{ marginBottom: 0, }}>软硬件一体化</div>
                    <div className="common-block-home-tips" style={{ marginTop: '30px', lineHeight: '26px', padding: '0 80px' }}>以标准信息平台建设为支撑，软件自主研发，硬件大厂OEM,软硬件深度结合为标准；结合新零售运营经验；支付服务全面、会员玩法多样、线上商城便捷，玩法私域流量；提供专属于农贸市场的一站式、精细化、数字化的降本增效解决方案。并为客户提供五星售后服务体系，为农贸市场数智化转型保驾护航。</div>
                    <div className="member-detail-service">
                        <img className="member-img-style" src={integration} alt="" />
                    </div>
                </div>
                <div className="common-block-home">
                    <div className="common-block-home-title">智慧农贸场景</div>
                    <div className="common-block-home-tips">打造一刻钟便民生活圈</div>
                    <div className="ponder-over">
                        <div className="ponder-over-detail">
                            <img className="ponder-over-img-style" src={supermarket2} alt="" />
                            <div className="ponder-over-title">供应保障中心</div>
                        </div>
                        <div className="ponder-over-detail">
                            <img className="ponder-over-img-style" src={supermarket2} alt="" />
                            <div className="ponder-over-title">食品安全中心</div>
                        </div>
                        <div className="ponder-over-detail">
                            <img className="ponder-over-img-style" src={supermarket2} alt="" />
                            <div className="ponder-over-title">便民服务中心</div>
                        </div>
                        <div className="ponder-over-detail">
                            <img className="ponder-over-img-style" src={supermarket2} alt="" />
                            <div className="ponder-over-title">邻里社交中心</div>
                        </div>
                        <div className="ponder-over-detail">
                            <img className="ponder-over-img-style" src={supermarket2} alt="" />
                            <div className="ponder-over-title">健康引领中心</div>
                        </div>
                    </div>

                    <div className="member-detail-service">
                        <img className="member-img-style" src={sceen} alt="" />
                    </div>

                </div>

                <div className="common-block-home">
                    <div className="common-block-home-title" style={{ marginBottom: 0, }}>智慧农贸的特点</div>
                    <div className="member-detail-service member-detail-service-1" style={{padding: '30px 200px 20px'}}>
                        <img className="member-img-style" src={speacial} alt="" />
                    </div>
                </div>



                <div className="common-block-home">
                    <div className="common-block-home-title" style={{ marginBottom: 0, }}>悦喵AI智慧市场方案能力</div>
                    <div className="member-detail-service" style={{ padding: '0px 160px' }}>
                        <img className="member-img-style" src={plan} alt="" />
                    </div>
                </div>

                <div className="common-block-home">
                    <div className="common-block-home-title" style={{ marginBottom: 0, }}>服务能力</div>
                    <div className="common-block-home-tips" style={{ marginBottom: 0, }}>信息化工具+运营服务</div>
                    <div className="service-and-operations">
                        
                        <div className="service-and-operations-content">
                            <img className="service-img-icon" src={advantage1} alt="" />
                            <div className="service-flex-title">数字化监管保民生</div>
                            <div className="detail-service-operations">
                                <div className="title-detail-operations">监管平台</div>
                                <div className="title-detail-operations">亮照经营</div>
                                <div className="title-detail-operations">食品检测</div>
                                <div className="title-detail-operations">电子台账</div>
                                <div className="title-detail-operations">食品追溯</div>
                            </div>
                        </div>

                        <div className="service-and-operations-content">
                            <img className="service-img-icon" src={advantage1} alt="" />
                            <div className="service-flex-title">精细化管理降成本</div>
                            <div className="detail-service-operations">
                                <div className="title-detail-operations">招商管理</div>
                                <div className="title-detail-operations">商户收银</div>
                                <div className="title-detail-operations">摊位管理</div>
                                <div className="title-detail-operations">商品管理</div>
                                <div className="title-detail-operations">商户管理</div>
                                <div className="title-detail-operations">大数据公示</div>
                                <div className="title-detail-operations">智能水电管理</div>
                                <div className="title-detail-operations">报表管理</div>
                                <div className="title-detail-operations">电子合同</div>
                                <div className="title-detail-operations">数据驾驶舱</div>
                            </div>
                        </div>

                        <div className="service-and-operations-content">
                            <img className="service-img-icon" src={advantage1} alt="" />
                            <div className="service-flex-title">数字化运营增收益</div>
                            <div className="detail-service-operations">
                                <div className="title-detail-operations">会员运营</div>
                                <div className="title-detail-operations">活动运营</div>
                                <div className="title-detail-operations">社群运营</div>
                                <div className="title-detail-operations">内容运营</div>
                                <div className="title-detail-operations">电商运营</div>
                            </div>
                        </div>
                        
                    </div>
                </div>

                
                
            </div >
        )
    }
}


export default SupermarketRetail